import './kp-selectable-loan-card.less';
import type {Component} from 'typings/portaro.fe.types';
import type {Loan} from 'typings/portaro.be.types';

export class KpSelectableLoanCardComponentController implements KpSelectableLoanCardComponentBindings {
    public loan: Loan;
}

/**
 * @ngdoc component
 * @name kpSelectableLoanCard
 * @module portaro.components.loan
 *
 * @param {Loan} loan
 *
 * @description
 *
 */
export default class KpSelectableLoanCardComponent implements Component<KpSelectableLoanCardComponentBindings> {
    public static componentName = 'kpSelectableLoanCard';

    public templateUrl = require('./kp-selectable-loan-card.tpl.ftl');

    public bindings = {
        loan: '<'
    } as const;

    public controller = KpSelectableLoanCardComponentController;
}

interface KpSelectableLoanCardComponentBindings {
    loan: Loan
}
